
/**
 *   1.点击查看更多 
 *   2.未登录情况下“登录查看价格”按钮
 */

const
	Util = require('../../../common/util.js'),
	
	
	// 初始化 "查看更多" 点击事件   -- 旧的
    /** 
	initExpandBtnClick = function(){
		$(".hli-price-list-wrap").delegate('.hli-expand-inner', 'click', function(){
			var
				_this = $(this),
				expandText = _this.find('span'),
				expandIcon = _this.find('.hli-icon'),
				autoHideTrs = _this.closest('.hl-item').find('.auto-hide'),
				myTrs = _this.closest('.hl-item').find('.mytr'); 
				
			if( expandIcon.hasClass('icon-down') ){
				expandIcon.removeClass('icon-down').addClass('icon-up');
				expandText.html('收起全部房型');
				$.each(autoHideTrs, function(i, o) {
					setTimeout(function(){
						$(o).find('td').removeClass('hidden');
					}, 50);
				});
				$.each(myTrs,function(z,w){
					$(myTrs).slideDown('fast');
				})
			}else{
				expandIcon.removeClass('icon-up').addClass('icon-down');
				expandText.html('展开全部房型');
				// let iconUp = $(autoHideTrs).find('.room-type-icon')
				$.each(autoHideTrs, function(i, o) {
					setTimeout(function(){
						$(o).find('td').addClass('hidden');
					}, 80);
					
					$(o).slideUp('fast');
				});

				$.each(myTrs,function(z,w){
					$(w).find('.new-btn').removeClass('hidden');
					$(w).find('.new-btn').find('span').html('更多');
					$(w).find('.new-btn').find('.room-type-icon').removeClass('room-type-up')
					$(w).find('.new-btn').find('.room-type-icon').addClass('room-type-down')
				})

				// setTimeout(function(){
				// 	// 当重新查询价格时，将搜索栏滚动到页面顶部
				// 	$('.search-line-outer')[0].scrollIntoView();
				// }, 200);

                setTimeout(() => {
                    //耗时0.5秒时间，滑动到指定元素（动效）
                    $('html,body').animate({
                        scrollTop : $(".hotel-price-table").offset().top
                    }, 200);
                }, 100)

			}

			// 点击收起，去除fix样式
			_this.closest('.fix-bottom').removeClass('fix-bottom');
			
			// 异步触发屏幕滚动事件
			// setTimeout(function(){
			// 	$(document).trigger('scroll');
			// }, 50)

		})
	},
    */

    // 初始化 "查看更多" 点击事件   -- 新的
	initExpandBtnClick = function(){
		$(".hli-price-list-wrap").delegate('.hli-expand-inner', 'click', function(){

			var _this = $(this);
			var	expandText = _this.find('span');
			var	expandIcon = _this.find('.hli-icon');
			var	autoHideTrs = _this.closest('.hl-item').find('.auto-hide');
			var	myTrs = _this.closest('.hl-item').find('.mytr'); 
				
			if( expandIcon.hasClass('icon-down') ){

                $(".myBody").find(".gt-one-tr").removeClass("click-more-css");
				expandIcon.removeClass('icon-down').addClass('icon-up');
				expandText.html('收起全部房型');
                
			}else{  

                $(".myBody").find(".gt-one-tr").addClass("click-more-css");
				expandIcon.removeClass('icon-up').addClass('icon-down');
				expandText.html('展开全部房型');

                setTimeout(() => {
                    //耗时0.5秒时间，滑动到指定元素（动效）
                    $('html,body').animate({
                        scrollTop : $(".hotel-price-table").offset().top
                    }, 200);
                }, 100)

			}

			// 点击收起，去除fix样式
			_this.closest('.fix-bottom').removeClass('fix-bottom');

		})
	},
	
	//未登录情况下“登录查看价格”按钮
	initAlertLogin = function () {
		$('.login-btn').click(function () {
			require('../../../common/loginBox/loginBox')();
        })
    };
	

// 酒店信息
module.exports = {
    run: function(){
    	// 初始化 "查看更多" 点击事件
    	initExpandBtnClick();
    	
    	initAlertLogin();
    }
}


// WEBPACK FOOTER //
// ./src/js/hotelDetail/modules/hotelPriceTable.js